import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Badge } from './Badge';

/**
 * SuperAdminModeBadge Component
 *
 * Displays a badge indicating that the user is in SuperAdmin mode.
 * Only renders if the user is a SuperAdmin.
 *
 * @param {Object} props
 * @param {boolean} props.isSuperAdmin - Whether the current user is a SuperAdmin
 * @param {string} props.className - Additional CSS classes
 */
export function SuperAdminModeBadge({ isSuperAdmin, className = '' }) {
  const { t } = useTranslation();

  if (!isSuperAdmin) {
    return null;
  }

  return (
    <Badge variant="info" className={className}>
      {t('common.superAdminMode', 'Modo SuperAdministrador')}
    </Badge>
  );
}

SuperAdminModeBadge.propTypes = {
  isSuperAdmin: PropTypes.bool.isRequired,
  className: PropTypes.string,
};
